import { c as _c } from "react/compiler-runtime";
import { HStack } from '@jaaq/hub-ui';
import { cn } from '@jaaq/hub-ui/cn';
import type { ReactElement } from 'react';

/**
 * 3-segment progress bar from the live Figma frames (40000021:62658,
 * 40000021:62584): caption "1/3" sitting alongside three rounded
 * segments. Filled segments are solid white; remaining ones are
 * `rgba(255,255,255,0.3)`.
 */
type ProgressBarProps = {
  current: number; // 1-indexed
  total: number;
  align?: 'left' | 'right';
  className?: string;
};
export const ProgressBar = t0 => {
  const $ = _c(15);
  const {
    current,
    total,
    align: t1,
    className
  } = t0;
  const align = t1 === undefined ? "left" : t1;
  const t2 = align === "right" && "justify-end";
  let t3;
  if ($[0] !== className || $[1] !== t2) {
    t3 = cn(t2, className);
    $[0] = className;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== current || $[4] !== total) {
    t4 = <span className="jaaq-caption text-white/80 leading-none">{current}/{total}</span>;
    $[3] = current;
    $[4] = total;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== total) {
    t5 = Array.from({
      length: total
    });
    $[6] = total;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== current || $[9] !== t5) {
    t6 = <HStack gap={1.5} aria-hidden="true">{t5.map((_, i) => <span key={i} className={cn("h-2 w-[62px] rounded-sm", i < current ? "bg-surface" : "bg-white/30")} />)}</HStack>;
    $[8] = current;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t3 || $[12] !== t4 || $[13] !== t6) {
    t7 = <HStack align="center" gap={3} className={t3}>{t4}{t6}</HStack>;
    $[11] = t3;
    $[12] = t4;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};